import { asyncLoadRouter } from '@router/helper'

const models = [
  {
    path: 'machines/models',
    component: asyncLoadRouter('manager/globals/machines/Models'),
    meta: {
      authorize: ['admin'],
      breadcrumb: (i18n) => [
        { text: i18n.t('activerecord.models.machine.other') },
        {
          text: i18n.t('activerecord.models.machine/model.other'),
          to: { name: 'manager-machines-models' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'manager-machines-models',
        component: asyncLoadRouter('manager/globals/machines/models/List'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.list') }] },
      },
      {
        path: 'new',
        name: 'manager-machines-models-new',
        component: asyncLoadRouter('manager/globals/machines/models/New'),
        meta: {
          breadcrumb: (i18n) => [
            {
              text: i18n.t('shared.actions.new'),
              to: { name: 'manager-machines-models-new' },
            },
          ],
        },
        props: { action: 'create' },
      },
      {
        path: ':model_id([A-Za-z\\d]{22})',
        name: 'manager-machines-models-show',
        component: asyncLoadRouter('manager/globals/machines/models/Show'),
        redirect: (to) => {
          return {
            name: 'manager-machines-models-edit',
            params: { model_id: to.params.model_id },
          }
        },
        meta: {
          breadcrumb: (i18n, params) => [
            {
              text: `ID ${params.model_id}`,
              to: {
                name: 'manager-machines-models-edit',
                params: { model_id: params.model_id },
              },
            },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-machines-models-edit',
            component: asyncLoadRouter('manager/globals/machines/models/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
        ],
      },
    ],
  },
]

export default models
